import React, { useState } from "react";
import { ConfigProvider, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const THEME = { token: { colorPrimary: "#fb310d", borderRadius: 8, fontFamily: "inherit", controlHeight: 38 } };

export const rangeOfPicker = (values) =>
  values && values[0] && values[1]
    ? { from: values[0].format("YYYY-MM-DD"), to: values[1].format("YYYY-MM-DD") }
    : null;

const presets = (today) => [
  { label: "Today", value: [today, today] },
  { label: "Last 7 days", value: [today.subtract(6, "day"), today] },
  { label: "This month", value: [today.startOf("month"), today] },
  { label: "Last month", value: [today.subtract(1, "month").startOf("month"), today.subtract(1, "month").endOf("month")] },
];

export default function PaymentsRangeFilter({ applied, loading, onSearch }) {
  const [draft, setDraft] = useState(applied ? [dayjs(applied.from), dayjs(applied.to)] : null);
  const today = dayjs();

  const allTime = () => {
    setDraft(null);
    onSearch(null);
  };

  return (
    <div className="stl-toolbar__group">
      <div className="stl-field">
        <span className="stl-field__label">Paid between</span>
        <ConfigProvider theme={THEME}>
          <RangePicker
            value={draft}
            onChange={setDraft}
            format="DD/MM/YYYY"
            presets={presets(today)}
            disabledDate={(day) => day.isAfter(today, "day")}
            placeholder={["From", "To"]}
            aria-label="Paid between"
          />
        </ConfigProvider>
      </div>
      <button type="button" className="stl-btn stl-btn--primary" disabled={loading} onClick={() => onSearch(rangeOfPicker(draft))}>
        <SearchOutlined /> Search
      </button>
      {applied && (
        <button type="button" className="stl-link-btn" onClick={allTime}>
          All time
        </button>
      )}
    </div>
  );
}
